// todo: refactor
export const encodedRID = (RID: string) => RID;
